import { render, staticRenderFns } from "./CustomerEditInfo.vue?vue&type=template&id=5f83f5dd&"
import script from "./CustomerEditInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerEditInfo.vue?vue&type=script&lang=js&"
import style0 from "./CustomerEditInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports